import { getApiClient } from './ApiClient'

// os_type, as the API validates it. Shared so the list and the form do not disagree about what
// platform 0 means -- the list used to print the raw number the form renders as a label.
export const PLATFORMS = [
  { value: 0, label: 'iOS' },
  { value: 1, label: 'Android' },
  { value: 2, label: 'web' },
  { value: 3, label: 'fitbit' },
  { value: 4, label: 'AppleTV' },
  { value: 5, label: 'FireOS' },
  { value: 6, label: 'Roku' },
  { value: 7, label: 'MobileWeb' },
  { value: 8, label: 'GoogleTV' },
]

export const PLATFORM_LABELS = PLATFORMS.reduce((acc, p) => ({ ...acc, [p.value]: `${p.label} (${p.value})` }), {})

export const experimentListPromise = (params) => {
  return getApiClient()
    .get('/experiments', { params })
    .then(resp => resp.data)
}

export const experimentDetailPromise = (id) => {
  return getApiClient()
    .get(`/experiments/${id}`)
    .then(resp => resp.data)
}

export const experimentCreatePromise = (body) => {
  return getApiClient()
    .post('/experiments', { body })
    .then(resp => resp.data)
}

export const experimentUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/experiments/${id}`, { body })
    .then(resp => resp.data)
}

export const experimentVariantCreatePromise = (experimentId, body) => {
  return getApiClient()
    .post(`/experiments/${experimentId}/variants`, { body })
    .then(resp => resp.data)
}

export const experimentVariantUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/experiment-variants/${id}`, { body })
    .then(resp => resp.data)
}

// user_experiment is read-only: assignment data, not configuration.
export const experimentAssignmentListPromise = (experimentId, params) => {
  return getApiClient()
    .get(`/experiments/${experimentId}/assignments`, { params })
    .then(resp => resp.data)
}
